import React, { createContext, useContext, ReactNode } from 'react';
import useServerStatus from '../hooks/useServerStatus';

interface ServerStatusContextType {
  online: boolean;
  loading: boolean;
}

const ServerStatusContext = createContext<ServerStatusContextType | undefined>(undefined);

interface ServerStatusProviderProps {
  children: ReactNode;
}

/**
 * Provider component for server status context
 * Makes the server status available throughout the application
 */
export const ServerStatusProvider: React.FC<ServerStatusProviderProps> = ({ children }) => {
  // Use the hook internally and pass its values to the context
  const status = useServerStatus();
  
  return (
    <ServerStatusContext.Provider value={status}>
      {children}
    </ServerStatusContext.Provider>
  );
};

/**
 * Hook for consuming the server status context
 * Returns the current server status
 */
export const useServerStatusContext = (): ServerStatusContextType => {
  const context = useContext(ServerStatusContext);
  
  if (context === undefined) {
    throw new Error('useServerStatusContext must be used within a ServerStatusProvider');
  }
  
  return context;
};

export default ServerStatusProvider; 